import { PaginatedResponse, useApi } from '@/api';
import { CardList, LinkButton, Link, ListSkeleton } from '@/components';
import {
  Flex,
  WalletAddress,
  CurrencyValue,
  ListItem
} from '@blockanalitica/ui';

type WalletsData = {
  wallet_address: string;
  market_underlying_address: string;
  market_symbol: string;
  borrow: string | null;
};

export default function TopBorrowers({
  marketAddress,
  network,
  ...rest
}: {
  marketAddress: string;
  network: string;
}) {
  const [data, error] = useApi<PaginatedResponse<WalletsData[]>>({
    url: `/markets/${marketAddress}/wallets/`,
    queryParams: {
      type: 'borrower',
      limit: '5',
      sort: '-borrow'
    }
  });

  if (error) {
    throw error;
  }

  if (!data) {
    return <ListSkeleton />;
  }

  return (
    <CardList
      title="Top Borrowers"
      action={
        <LinkButton to="borrowers" variant="secondary">
          view all
        </LinkButton>
      }
      {...rest}>
      {data['results'].length > 0 &&
        data['results'].map((row) => (
          <ListItem
            // @ts-ignore
            as={Link}
            key={row.wallet_address}
            to={`./borrowers/${row.wallet_address}`}
            relative="path">
            <Flex justifyContent="space-between">
              <WalletAddress address={row.wallet_address} />

              <CurrencyValue
                value={row.borrow}
                options={{
                  currency: {
                    name: row.market_symbol,
                    address: row.market_underlying_address,
                    network: network
                  }
                }}
              />
            </Flex>
          </ListItem>
        ))}
    </CardList>
  );
}
